export const formatDateDmy = (value: string): string => {
  const digits = value.replace(/\D/g, '').slice(0, 8);
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
};

export const formatNI = (value: string): string => {
  const s = value
    .toUpperCase()
    .replace(/\s+/g, '')
    .replace(/[^A-Z0-9]/g, '')
    .slice(0, 9);
  const parts: string[] = [];
  if (s.length > 0) parts.push(s.slice(0, 2));
  if (s.length > 2) parts.push(s.slice(2, 4));
  if (s.length > 4) parts.push(s.slice(4, 6));
  if (s.length > 6) parts.push(s.slice(6, 8));
  if (s.length > 8) parts.push(s.slice(8, 9));
  return parts.join(' ');
};

export const capitaliseWords = (s: string): string =>
  s
    .toLowerCase()
    .replace(/\b([a-z])/g, (_, c: string) => c.toUpperCase())
    .replace(/(['\-])([a-z])/g, (_, sep: string, c: string) => sep + c.toUpperCase());

// Lighter variant: uppercases word-initial lowercase letters only, without
// touching existing capitals (so "MacDonald" survives and "O'Brien" works).
// Safe to run on every keystroke.
export const capitaliseWordsLive = (s: string): string =>
  s
    .replace(/\b([a-z])/g, (_, c: string) => c.toUpperCase())
    .replace(/(['\-])([a-z])/g, (_, sep: string, c: string) => sep + c.toUpperCase());

export const cx = (...classes: Array<string | false | null | undefined>) =>
  classes.filter(Boolean).join(' ');
